import AppstoreFilled from "@ant-design/icons/AppstoreFilled";
import Title from "common/Typography/Title";
import Select from "common/Select/Select";
import React from "react";
import styled from "styled-components";
import Text from "common/Typography/Text";
import useWorkspace from "utils/hooks/useWorkspace";
import { WorkspaceType } from "@shared/types";
import { WORKSPACE_TO_DISPLAY_NAME } from "@shared/features/workspaces/constants";
import { useBottomNavigator } from "utils/hooks/misc";

interface WorkspaceSelectorProps {
  workspace: WorkspaceType | undefined;
}

const WorkspaceSelector = ({ workspace }: WorkspaceSelectorProps) => {
  const { onWorkspaceChange, isWorkspaceValid, onClickDisabledInterface } =
    useWorkspace();
  const bottomNavigatorData = useBottomNavigator();

  const getValue = () => {
    if (workspace === WorkspaceType.DEMO) return WorkspaceType.USER;
    return workspace;
  };

  const getIsDisabled = (workspace: WorkspaceType) => {
    if (workspace === WorkspaceType.USER) {
      return (
        !isWorkspaceValid(WorkspaceType.USER) &&
        !isWorkspaceValid(WorkspaceType.DEMO)
      );
    } else {
      return !isWorkspaceValid(workspace);
    }
  };

  const onChange = (value: WorkspaceType) => {
    if (
      (value === WorkspaceType.USER && workspace === WorkspaceType.ADMIN) ||
      value === WorkspaceType.ADMIN
    ) {
      onWorkspaceChange(value as WorkspaceType);
    }
  };

  const options = [WorkspaceType.ADMIN, WorkspaceType.USER].map((workspace) => {
    const isDisabled = getIsDisabled(workspace);
    return {
      value: workspace,
      label: (
        <StyledText
          $isDisabled={isDisabled}
          onClick={isDisabled ? onClickDisabledInterface : undefined}
        >
          {WORKSPACE_TO_DISPLAY_NAME[workspace]}
        </StyledText>
      ),
    };
  });

  return (
    <>
      <WorkspaceTitleWrapper>
        <AppstoreFilled
          style={{
            marginRight: bottomNavigatorData.shouldDisplay ? 6 : 10,
            fontSize: bottomNavigatorData.shouldDisplay ? 12 : 16,
          }}
        />
        <Title
          level={bottomNavigatorData.shouldDisplay ? 5 : 4}
          type="secondary"
        >
          WORKSPACES
        </Title>
      </WorkspaceTitleWrapper>
      <StyledSelect
        value={getValue()}
        onChange={(value) => onChange(value as WorkspaceType)}
        rounded={true}
        bordered={false}
        style={{ marginTop: bottomNavigatorData.shouldDisplay ? 8 : undefined }}
        options={options}
        mobileTitle="Workspaces"
      />
    </>
  );
};

export default WorkspaceSelector;

const WorkspaceTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.colors.secondaryGrey};
`;
const StyledSelect = styled(Select)`
  width: 100%;
  margin: 16px 0;
  .ant-select-selector {
    background: ${(p) => p.theme.colors.lightBlue}!important;
  }
`;
const StyledText = styled(Text)<{ $isDisabled: boolean }>`
  ${(p) =>
    p.$isDisabled &&
    `
    color: ${p.theme.colors.secondaryGrey}!important;
    cursor: auto;
 `}
`;
